export default function(state={
    subData: {},
    subCount: 0
    }, action) {
        switch(action.type) {
        case "SUBTABLE":
            return {
                subData: action.payload.tableData,
                subCount: action.payload.tableCounter
            };

        case "CELL_SUBDATA":
            {
                return {
                    subData: action.payload.data.tableData.subData,
                    subCount: action.payload.data.tableData.subCount
                }
            }

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerSubTable.js